module.exports = __webpack_public_path__ + "img/newsletter-bg.71e4782d.png";